<template>
  <PageWrapper class="text-center">
    <v-img
      contain
      height="110"
      src="/img/mail-icon.png"
      class="ma-4"
    />

    <v-card-text v-if="loading || error">
      <div v-if="loading">
        <v-progress-circular indeterminate primary /><br>
        Einladung wird
        <template v-if="action === 'ACCEPT'">angenommen</template>
        <template v-else>geladen</template>
        ...
      </div>
      <v-alert v-else-if="error" type="error">
        <template v-if="error === 404">
          <strong>Einladung nicht gefunden.</strong><br>
          Entweder wurde die Einladung bereits angenommen oder ist abgelaufen.
        </template>
        <template v-else>Ungültiger Einladungs-Link</template>
      </v-alert>
    </v-card-text>

    <template v-else-if="invitation">
      <v-card-title>
        <i>{{invitation.creator.name}}</i> hat dich in den Raum
        <i>{{invitation.room.name}}</i> eingeladen
      </v-card-title>

      <v-card-subtitle v-if="invitation.room.description">
        Raumbeschreibung: <i>{{invitation.room.description}}</i>
      </v-card-subtitle>

      <v-card-text>
        <v-btn
          :href="`/select-account?state=${encodeURIComponent(`login_redir=/invitation/${invitation.id}/accept`)}`"
          color="accent"
          large
          class="my-4"
        >
          <template v-if="loggedIn">Konto auswählen</template>
          <template v-else>Einloggen</template>
          und Raum beitreten
        </v-btn>

        <small class="d-block text-left mt-4">
          Die Einladung ist nur einmalig und für maximal 14 Tage gültig.<br>
          Nachdem du einem Raum beigetreten bist, kannst du diesen auch jederzeit wieder verlassen.
        </small>
      </v-card-text>
    </template>

    <template #links>
      <a href="https://xidras.io/services/XidrasTransfer/">
        Was ist XidrasTransfer?
      </a>
    </template>
  </PageWrapper>
</template>

<script>
  import PageWrapper from '../components/PageWrapper';


  export default {
    name: 'InviteAccept',

    components: {
      PageWrapper
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => vm.update());
    },

    beforeRouteUpdate(to, from, next) {
      this.update();
      next();
    },

    // Props are set by router.
    props: {
      invitationId: {
        type: String,
        default: ''
      },
      action: {
        type: String,
        default: 'GET' // or 'ACCEPT'
      }
    },

    data: () => ({
      documentTitle: 'Einladung',
      invitation: null,
      loading: false,
      error: false
    }),

    computed: {
      loggedIn() {
        return this.$store.getters['session/getUser']?.loggedIn;
      }
    },

    mounted() {
      // Fix HMR.
      if (!this.invitation && !this.error && !this.loading) {
        this.update(this.$route.query.inv);
      }
    },

    methods: {
      async update() {
        if (this.action === 'ACCEPT') {
          await this.action_accept();
        } else {
          await this.action_load();
        }
        sessionStorage.removeItem('login_redir');
      },

      async action_load() {
        if (!this.invitationId) {
          return this.error = 400;
        }

        this.error = false;
        this.loading = true;

        try {
          const response = await this.$api.post('InvitationGet', {id: this.invitationId});
          this.invitation = response.data;

        } catch (error) {
          this.invitation = null;
          this.error = error.response?.status ?? 500;
        }

        this.loading = false;
      },

      async action_accept() {
        if (!this.loggedIn) {
          return this.$router.replace({path: `/invitation/${this.invitationId}`});
        }

        this.error = false;
        this.loading = true;

        try {
          const {data} = await this.$api.post('InvitationAccept', {id: this.invitationId});
          this.$router.push({path: `/share?room=${data.roomId}`});

        } catch (error) {
          this.error = error.response?.status ?? 500;
        }

        this.loading = false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .v-alert {
    text-align: left;
    margin-bottom: 0;
  }

  .v-card__text small {
    line-height: 1.2;
  }

  .v-btn {
    white-space: normal;

    &::v-deep .v-btn__content {
      flex: auto;
    }
  }
</style>
